export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'code', label: 'Code', sortable: true },
    { key: 'short_info', label: 'Short Info', sortable: true },
    { key: 'letter_type', label: 'Letter Type', sortable: true },
    { key: 'period', label: 'Period', sortable: true },
    { key: 'to_org', label: 'To Org', sortable: true },
    { key: 'letter_status', label: 'Letter Status', sortable: true },
    { key: 'actions', label: 'Actions' },
  ]

  return {
    tableColumns,
  }
}
